import React from "react";
import { useTranslation } from "react-i18next";
import { Quote } from "lucide-react";

const AVATARS = [
  "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=120&h=120&fit=crop",
  "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=120&h=120&fit=crop",
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=120&h=120&fit=crop",
];

const LOGOS = [
  "KNHS",
  "Stal De Beemden",
  "EquiVet Praktijk",
  "Manege Heuvelrug",
  "Hippisch Centrum Zuid",
  "Veulenopfok NL",
];

export const SocialProof = () => {
  const { t } = useTranslation();
  const testimonials = t("socialProof.testimonials", { returnObjects: true }) || [];

  return (
    <section
      id="testimonials"
      data-testid="social-proof-section"
      className="bg-[hsl(var(--surface-secondary))] py-24 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--sand-dark))]">
            {t("socialProof.eyebrow")}
          </p>
          <h2 className="mt-4 font-display text-4xl font-medium leading-[1.05] text-[hsl(var(--ink))] text-balance sm:text-5xl lg:text-6xl">
            {t("socialProof.title")}
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {testimonials.map((t2, i) => (
            <figure
              key={t2.name}
              data-testid={`testimonial-${i}`}
              className={`flex flex-col justify-between rounded-3xl border border-[hsl(var(--border))] bg-[hsl(var(--surface))] p-8 ${
                i === 1 ? "lg:scale-[1.02]" : ""
              }`}
            >
              <Quote
                className="h-8 w-8 text-[hsl(var(--sand-dark))]"
                strokeWidth={1.2}
              />
              <blockquote className="mt-6 font-display text-2xl leading-snug text-[hsl(var(--ink))]">
                "{t2.quote}"
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-3">
                <img
                  src={AVATARS[i] || AVATARS[0]}
                  alt=""
                  className="h-11 w-11 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-medium text-[hsl(var(--ink))]">
                    {t2.name}
                  </p>
                  <p className="text-xs text-[hsl(var(--ink-soft))]">{t2.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-16 overflow-hidden">
          <div className="flex w-max animate-marquee-x items-center gap-12">
            {[...LOGOS, ...LOGOS].map((l, i) => (
              <span
                key={i}
                className="whitespace-nowrap font-display text-xl text-[hsl(var(--ink-soft))]"
              >
                · {l}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
